/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React from 'react'
import Dropdown from '../Dropdown'
import InputBox from '../InputBox'
import { motion } from 'framer-motion'
import { useRef,useState } from 'react'
import CustomDatePicker from '../DatePicker'
import dayjs from 'dayjs'
import { useOnClickOutside } from '../../CommonMethods/OutsideClick'
export default function FilterBtn({isFilterOpen,setIsFilterOpen,handleApplyFilter,isFilterOrganization,initialState,filterValues,setFilterValues,handleOpenFilter,isAdminActivity,orgUserFilter,isActivityexport}) {

    const [dateError, setdateError] = useState(false)
    function handleSelectDate(id,date,dateString,termkey){
        if(id==="filter_start_date"){
            setFilterValues((prv) => ({
                ...prv,
                filter_start_date: dateString,
            }));
        }
        else{
            setFilterValues((prv) => ({
                ...prv,
                filter_end_date: dateString,
            }));
        }
        
    }

    const handleCheck=()=>{
        
        if((dayjs(filterValues.filter_end_date).isBefore(dayjs(filterValues.filter_start_date)))){
            return true
        }
        return false
    }
    function handleOnChangeInput(id,option){
        const fieldToUpdate = {
            column_field:"column_field",
            action_performed:"action_performed",
           
        }[id];
        if(fieldToUpdate){
            setFilterValues((prev)=>({
                ...prev,
                [fieldToUpdate]:option
            }))
        }
    }
    return (
        <div className={`relative ml-2.5 ${orgUserFilter || isActivityexport ? "mb-0":"mb-2.5"}`}>
            <button id='filter' type='button' className='flex items-center border border-[#972E4C] rounded-[15px] px-4 py-2 min-w-max' onClick={()=>{handleOpenFilter(),setdateError(false)}}>
                <img src="/images/filter_icon.svg" alt="icon" loading='lazy' decoding='async' />
                <span className='text-lg font-semibold text-[#972E4C] ml-2.5'>Filter</span>
            </button>
            {
                isFilterOpen && 
               
                    <div  className={`absolute top-14 right-0 xl:left-[-344px] ${isAdminActivity!==undefined?'left-[-341px]':'left-[-84px]'} bg-white rounded-[15px] border border-[#D296B2] px-2.5 pt-4 py-[26px] shadow-s2 w-[453px] z-[99]`}>
                        <div className='flex justify-between items-center mb-4'>
                            <p className='text-sm font-semibold text-[#52555D]'>Filter by:</p>
                            {dateError &&<p className="text-xs text-red-500 mt-2 mr-8">Please select the valid date range.</p>}
                            <button type='button' onClick={()=>{setIsFilterOpen(!isFilterOpen),setFilterValues(initialState),setdateError(false)}}>
                                <img src="/images/cross_mark_gray.svg" alt="icon" />
                            </button>
                        </div>
                        <div className='flex flex-wrap -mx-2'>
                            <div className='w-1/2 px-2 mb-4'>
                                <div className='w-full'>
                                    <CustomDatePicker 
                                        id={"filter_start_date"}
                                        classKey={'border border-[#C5C9DA]  rounded-lg px-3.5 py-[11px] text-base font-normal text-[#000B17] w-full placeholder:text-[#52555D] outline-none bg-white flex justify-between items-center'}
                                        format="MMM DD, YYYY"
                                        state={filterValues}
                                        placeholder={"Select start date"}
                                        label={"Start Date"} 
                                        termkey={filterValues?.filter_start_date}
                                        handleSelect={handleSelectDate}
                                        imageClass={true}
                                        setdateError={setdateError}
                                    />
                                </div>
                            </div>
                            <div className='w-1/2 px-2 mb-4'>
                                <div className='w-full'>
                                    <CustomDatePicker 
                                        label={"End Date"} 
                                        classKey={'border border-[#C5C9DA]  rounded-lg px-3.5 py-[11px] text-base font-normal text-[#000B17] w-full placeholder:text-[#52555D] outline-none bg-white flex justify-between items-center'}
                                        placeholder={"Select end date"}
                                        format="MMM DD, YYYY"
                                        state={filterValues}
                                        termkey={filterValues?.filter_end_date}
                                        handleSelect={handleSelectDate}
                                        id={"filter_end_date"}
                                        setdateError={setdateError}
                                    />
                                </div>
                            </div>
                            {isFilterOrganization===undefined &&<>
                                <div className='w-1/2 px-2 mb-4'>
                                    <div className="w-full">
                                        <Dropdown
                                            label={"Field"} 
                                            placeholder={"Select field"}
                                            id={"column_field"}
                                            htmlFor={"dateFormat"}
                                            filterScroll={true}
                                            handleSelect={handleSelectDate}
                                            value={filterValues.column_field}
                                            options={['Email Address','Mobile Number','Main Number','County Code','User Type','User ID','Status','Profile Page']}
                                            handleOnChangeInput={handleOnChangeInput}
                                        />
                                    </div>
                                </div>
                                <div className='w-1/2 px-2 mb-4'>
                                    <div className="w-full">
                                        <Dropdown
                                            label={"Action Performed"} 
                                            placeholder={"Select Action performed"}
                                            id={"action_performed"}
                                            htmlFor={"dateFormat"}
                                            filterScroll={true}
                                            value={filterValues.action_performed}
                                            options={['Created','Updated','Deleted','Activated','Deactivated','View']}
                                            handleOnChangeInput={handleOnChangeInput}
                                        />
                                    </div>
                                </div>
                            </>}
                        </div>
                        <div className="flex mt-[13px] justify-between">
                            <button  onClick={()=>{handleApplyFilter(false),setdateError(false),setFilterValues(initialState),setIsFilterOpen(false)}}
                                id="Cancel"
                                className="py-2.5 px-4 rounded-[16px] border border-[#972E4C] text-lg font-semibold text-[#972E4C] mr-[38px]" 
                            >Clear All</button>
                            <button  
                                onClick={()=>{
                                    if(handleCheck())
                                    {setdateError(true) 
                                        return}
                                    handleApplyFilter(true),setIsFilterOpen(false)}}
                                type='button'
                                id="apply-filter"
                                disabled={Object.values(filterValues).every(value => typeof value === 'string' && value.trim() === '')} 
                                className={`py-2.5 w-[106px] px-4 rounded-[16px]  ${Object.values(filterValues).every(value => typeof value === 'string' && value.trim() === '')?'bg-[#777C88]':'bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] border border-[#972E4C]'}   text-lg font-semibold text-[#FFFFFF] hover:duration-75 reset_password_conf`}>
                                Apply
                            </button>
                        </div>
                    </div>
                // </motion.div>
            }
        </div>  
    )
}
